import { Component, OnInit } from '@angular/core';
import { RequisitionExceptionDataService } from '../../data-services/requisitionException.service';
import { SelectItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router'
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { FieldsetModule } from 'primeng/fieldset';
import { RouterModule } from '@angular/router';

@Component({
   selector: 'app-requisitionException-add',
   templateUrl: './requisitionException.add.html',
   providers: [DialogService],
   imports: [FormsModule, SelectModule, DatePickerModule, FieldsetModule, RouterModule]
})
export class RequisitionExceptionAddComponent implements OnInit {

   constructor(private requisitionExceptionDataService: RequisitionExceptionDataService,
      private router: Router,
      private route: ActivatedRoute) {
   }

   requisitionException;
   loading: boolean;
   requisitions: SelectItem[];
   assignedTos: SelectItem[];
   resolvers: SelectItem[];
  Id: number;

   ngOnInit() {
     this.loading = true;

     //this.route.params.subscribe(params => {
     //  this.Id = params['Id'];
     //});

     this.route.queryParamMap
       .subscribe(params => {
         this.Id = +params.get('Id') || 0;

         if (this.Id === 0) {
           this.requisitionExceptionDataService.getEmptyModel().subscribe((data: any) => {
             this.requisitionException = data;
             this.loading = false;
           });
         }
         else {
           this.requisitionExceptionDataService.getRequisitionException(this.Id.toString()).subscribe((data: any) => {
             this.requisitionException = data;
             this.loading = false;
           });
         }

       });

     this.requisitions = [
       { label: '', value: '' },
       { label: 'Accession 1', value: '154' },
       { label: 'Accession 2', value: '155' },
       { label: 'Accession 3', value: '156' },
       { label: 'Accession 4', value: '157' }
     ];

     this.assignedTos = [
       { label: '', value: '' },
       { label: 'Bill Jones', value: 'Bill.Jones@email.com' },
       { label: 'Jim Walter', value: 'Jim.Walter@email.com' },
       { label: 'Phil Hart', value: 'Phil.Hart@email.com' },
       { label: 'Suzie Wilson', value: 'Suzie.Wilson@email.com' }
     ];

     this.resolvers = [
       { label: '', value: '' },
       { label: 'Bill Jones', value: 'Bill.Jones@email.com' },
       { label: 'Jim Walter', value: 'Jim.Walter@email.com' },
       { label: 'Phil Hart', value: 'Phil.Hart@email.com' },
       { label: 'Suzie Wilson', value: 'Suzie.Wilson@email.com' }
     ];
  }

  public saveRequisitionException() {

    //if (this.client) {
    //  this.package.ClientId = this.client.Id;
    //}

    this.requisitionExceptionDataService.saveRequisitionException(this.requisitionException).subscribe(() => {
      this.router.navigate(['/requisitionException-list']);
    });
  }

}
